import { Gear, SquaresFour, User, Cards, Phone } from "phosphor-react";
import { COLORS } from "../../../Helper/Colors";
import React from "react";
export const mainNav = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: <SquaresFour size={24} color={COLORS.navColor} weight="fill" />,
    isUniversalRoute: true,
  },
  {
    name: "User Management",
    url: "/user-management",
    icon: <User size={24} color={COLORS.navColor} weight="fill" />,
  },
  // {
  //   name: "Notification management",
  //   url: "/notification-management",
  //   icon: <BellRinging size={24} color={COLORS.navColor} weight="fill" />,

  // },
  {
    name: "StaticPage Management",
    url: "/staticpage",
    icon: <Cards size={24} color={COLORS.navColor} weight="fill" />,
  },
  {
    name: "Contact Us",
    url: "/contact-us",
    icon: <Phone size={24} color={COLORS.navColor} weight="fill" />,
    isUniversalRoute: true,
  },
  {
    name: "Profile & Settings",
    url: "/profile-settings",
    icon: <Gear size={24} color={COLORS.navColor} weight="fill" />,
    isUniversalRoute: true,
  },
];
